export const FireAlertMessage = {
  delete: "Are you sure you want to delete?",
  changeAction: "Are you sure to proceed with the action?",
  edit:"Are you sure you want to redirect",
  statusChanges: "Are you sure you want to change the status?",
  editChanges: "Are you sure you want to edit this item?"
};
